import { createNgReactBridgeDirective } from '../../react-bridge'
import { ServerMetadata } from '../../../components/server-details'

export const serverMetadata = createNgReactBridgeDirective(
  'reactServerMetadata',
  [],
  ServerMetadata,
  ['environment', 'type', 'path', 'logLevel', 'language', 'os']
)
